export default __webpack_public_path__ + "static/media/icn3.33ce77dd.PNG";